// extracted by mini-css-extract-plugin
export default {"textGeneralInfo":"PatientInfoText_textGeneralInfo__Qc+WO","text":"PatientInfoText_text__jOmpv"};